import { useState, useEffect, useRef, useMemo } from 'react';
import { db } from "../../firebase"; // <-- AGREGA ESTA LÍNEA, ajusta si es necesario
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import IceCreamPOS from "../POS/IceCreamPOS";
import RecipeChoicePOS from "../POS/RecipeChoicePOS";
import { collection, query, where, orderBy, getDocs, addDoc, doc, writeBatch, increment, limit, serverTimestamp, onSnapshot, startAt, endAt, updateDoc, setDoc } from "firebase/firestore";
import { useSettings } from '../../context/SettingsContext';
import { useProducts } from '../../context/ProductsContext';
import { useOfflineSync } from '../../context/OfflineSyncContext';
import {
  clearCachedOfflineCash, getOpenCashStatus, getPendingOfflineCashOpen, openCashRegisterOfflineAware,
} from '../../lib/cashApi';
import { clearSaleAttempt, createSaleFingerprint, getOrCreateSaleAttempt, processSaleApi } from '../../lib/salesApi';
import {
  enqueueOfflineSale,
  listOfflineSales,
  subscribeOfflineSales,
} from '../../lib/offlineSalesQueue';
import { printTicket } from '../../services/printService';
import { normalizePrintingSettings } from '../../lib/printing';
import { requiresDirectStock, resolveRequestedSaleQuantity } from '../../lib/productStockPolicy';
import { markExpensesCacheDirty } from '../../lib/expensesCache';
import { isProductAvailableToday, resolvePromotionProduct } from '../../lib/promotionRules';


// Normaliza texto para búsquedas: ignora tildes, mayúsculas/minúsculas y espacios extra.
const normalizeSearchText = (value = '') =>
  String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');

// Helper: YYYY-MM-DD en horario local.
// IMPORTANTE: una fecha que ya viene como "YYYY-MM-DD" NO se debe volver
// a convertir con new Date(), porque JavaScript la interpreta como UTC y en
// Colombia puede retrocederla al día anterior (ej. 2026-08-20 -> 2026-08-19).
const toLocalYMD = (value = new Date()) => {
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return trimmed;
  }

  let resolved = value;

  // Timestamp de Firestore en cliente.
  if (value?.toDate && typeof value.toDate === 'function') {
    resolved = value.toDate();
  // Timestamp serializado por Firebase Admin a través de la API.
  } else if (value && typeof value === 'object') {
    const seconds = Number(value._seconds ?? value.seconds);
    if (Number.isFinite(seconds)) resolved = new Date(seconds * 1000);
  }

  const d = resolved instanceof Date ? resolved : new Date(resolved);
  if (Number.isNaN(d.getTime())) return '';

  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// Fecha a medianoche local (evita que Firestore la muestre “corrido” de día)
const toLocalMidnight = (ymd) => {
  const parts = typeof ymd === 'string' ? ymd.split('-').map(Number) : [];
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) {
    const fallback = new Date();
    fallback.setHours(0, 0, 0, 0);
    return fallback;
  }
  const [y, m, d] = parts;
  const dt = new Date();
  dt.setFullYear(y, m - 1, d);
  dt.setHours(0, 0, 0, 0);
  return dt;
};

// --- Reusable block: Cliente + Pagos ---
function PaymentsBlock({
  paymentOptions,
  paymentMethod, setPaymentMethod,
  amountReceived, setAmountReceived,
  showSecondPayment, setShowSecondPayment,
  secondPaymentMethod, setSecondPaymentMethod,
  secondAmountReceived, setSecondAmountReceived,
  missing, changeCalc, total, fmtCOP,
customerInput, setCustomerInput, setCustomerName, setSelectedCustomer,
 customerSuggestions, setCustomerSuggestions
}) {
  return (
    <div className="space-y-4">
      {/* CLIENTE */}
      <div>
        <div className="relative">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            CLIENTE (escribe cédula o nombre)
          </label>
          <input
            type="text"
            value={customerInput}
            
onChange={(e) => {
  const v = e.target.value;            // ← sin .trim() para no borrar espacios al tipear
  setCustomerInput(v);
  if (!/^\d+$/.test(v)) {
    setCustomerName(v.trim());         // ← aquí sí, para mantener limpio el estado del nombre
    setSelectedCustomer(null);
  }
}}
            placeholder="Ej: 1092… o Juan Pérez"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 shadow-sm"
          />
          {customerSuggestions.length > 0 && customerInput.trim() !== '' && (
            <div className="absolute z-50 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-auto">
              {customerSuggestions.map(c => (
                <button
                  key={c.id}
                  type="button"
onClick={() => {
  setSelectedCustomer(c);
  setCustomerInput(c.name || '');  // ← mostrar el nombre en el input
  setCustomerName(c.name || '');
  setCustomerSuggestions([]);
}}
                  className="w-full text-left px-4 py-2 hover:bg-gray-50"
                >
                  <div className="font-medium">{c.name || "(sin nombre)"}</div>
                  <div className="text-xs text-gray-500">CC: {c.cedula} • {c.phone || ""}</div>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* MÉTODO PRINCIPAL */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Método de Pago Principal</label>
        <select
          value={paymentMethod}
          onChange={(e) => {
            setPaymentMethod(e.target.value);
            setAmountReceived(0);
          }}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 shadow-sm"
        >
{paymentOptions.map(option => (
  <option key={option} value={option}>{option}</option>
))}
        </select>
      </div>

      {/* MONTO PRINCIPAL */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Monto Recibido ({paymentMethod})</label>
        <input
          type="number"
          min="0"
          inputMode="numeric"
          pattern="[0-9]*"
          value={amountReceived === 0 ? '' : amountReceived}
          placeholder="Ej: 50000"
          onChange={e => {
            let val = e.target.value.replace(/\D/g, '').replace(/^0+/, '');
            setAmountReceived(val === '' ? 0 : Number(val));
          }}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 shadow-sm"
        />
      </div>

      {/* SEGUNDO MÉTODO */}
      {!showSecondPayment && (
        <button
          onClick={() => setShowSecondPayment(true)}
          className="w-full px-4 py-2 bg-gray-100 text-gray-700 rounded-lg border border-gray-300 hover:bg-gray-200 transition duration-200"
        >
          + Añadir Segundo Método de Pago
        </button>
      )}

      {showSecondPayment && (
        <div className="border-t border-gray-200 pt-4 mt-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Segundo Método de Pago</label>
          <select
            value={secondPaymentMethod}
            onChange={(e) => setSecondPaymentMethod(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 shadow-sm mb-2"
          >
            <option value="">Seleccionar...</option>
            {paymentOptions.map(option => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
          <label className="block text-sm font-medium text-gray-700 mb-1">Monto Recibido ({secondPaymentMethod || '—'})</label>
          <input
            type="number"
            min="0"
            inputMode="numeric"
            pattern="[0-9]*"
            value={secondAmountReceived === 0 ? '' : secondAmountReceived}
            placeholder={missing > 0 ? `Sugerido: ${fmtCOP(Math.max(0, total - Number(amountReceived || 0)))}` : '0'}
            onChange={e => {
              let val = e.target.value.replace(/\D/g, '').replace(/^0+/, '');
              setSecondAmountReceived(val === '' ? 0 : Number(val));
            }}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 shadow-sm"
          />
          <button
            onClick={() => { setShowSecondPayment(false); setSecondPaymentMethod(''); setSecondAmountReceived(0); }}
            className="mt-2 text-red-500 hover:text-red-700 text-sm"
          >
            Eliminar Segundo Método
          </button>
        </div>
      )}

      {/* FALTAN / CAMBIO */}
      <div className="mt-3 text-lg font-semibold flex justify-between">
        {missing > 0 ? (
          <>
            <span className="text-red-600">Faltan:</span>
            <span className="text-red-600">
              {fmtCOP(missing)}
            </span>
          </>
        ) : (
          <>
            <span className="text-green-600">Cambio:</span>
            <span className="text-green-600">
              {fmtCOP(changeCalc)}
            </span>
          </>
        )}
      </div>
    </div>
  );
}



// Reutilizar un único iframe para imprimir (evita crearlo/destruirlo cada venta)
let __printFrame = null;


// helpers de notificación
const notify = {
  success: (msg) => toast.success(msg, {
    autoClose: 2200,
    closeOnClick: true,
    pauseOnHover: false
  }),
  error:   (msg) => toast.error(msg,   { autoClose: 3000 }),
  warn:    (msg) => toast.warn(msg,    { autoClose: 2800 }),
  info:    (msg) => toast.info(msg,    { autoClose: 2500 }),
};


const STORE_ID = "SUC001"; // o toma esto de props/config



// Devuelve la última caja ABIERTA del usuario (si existe)
const checkCajaAbierta = async (usuario) => {
  return getOpenCashStatus(usuario);
};



const aperturarCaja = async (usuario, monto, isOnline) => {
  const cash = await openCashRegisterOfflineAware({
    currentUser: usuario,
    amount: Number(monto),
    isOnline,
    storeId: STORE_ID,
  });
  if (!cash?.id) {
    throw new Error("No se pudo aperturar la caja.");
  }
  return cash;
};




const POSView = ({ onBack, products, currentUser, cashRegisterStatus, pendingOrders, onOrderProcessed, loadingAll, fullReady }) => {
  const { isOnline, isSyncing: syncingOfflineSales, syncNow } = useOfflineSync();
  const wasOfflineRef = useRef(false);
  const [offlineSales, setOfflineSales] = useState([]);
  const { settings } = useSettings();
  const { refreshProducts } = useProducts();
  const printingSettings = useMemo(() => normalizePrintingSettings(settings?.printing), [settings?.printing]);
  // Solo productos finales (se venden). Excluye type === 'insumo'
 const sellableProducts = useMemo(
   () => (products || [])
     .filter(p => p?.deleted !== true && (p.type || 'final') !== 'insumo')
     .filter(p => isProductAvailableToday(p))
     .map(p => resolvePromotionProduct(p, products || []))
     .filter(Boolean),
    [products]
  );const [cart, setCart] = useState(() => {
  const saved = localStorage.getItem('valenpos_cart');
  return saved ? JSON.parse(saved) : [];
});

  const currencyFormatter = useMemo(() => {
    const currency = settings?.currency || 'COP';
    try {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency,
        maximumFractionDigits: 0,
      });
    } catch (_) {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        maximumFractionDigits: 0,
      });
    }
  }, [settings?.currency]);

  const fmtCOP = (value) => {
    try {
      return currencyFormatter.format(Number(value || 0));
    } catch (_) {
      return (Number(value) || 0).toLocaleString('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
      });
    }
  };

  const taxRate = settings?.taxEnabled ? Number(settings?.taxRate || 0) : 0;

useEffect(() => {
  localStorage.setItem('valenpos_cart', JSON.stringify(cart));
}, [cart]);

useEffect(() => {
  let active = true;
  const refreshQueue = async () => {
    try {
      const records = await listOfflineSales();
      if (active) setOfflineSales(records);
    } catch (error) {
      console.error('No se pudo leer la cola de ventas offline', error);
    }
  };
  refreshQueue();
  const unsubscribe = subscribeOfflineSales(refreshQueue);
  return () => {
    active = false;
    unsubscribe();
  };
}, []);

useEffect(() => {
  if (!isOnline) {
    wasOfflineRef.current = true;
    return;
  }
  if (wasOfflineRef.current) {
    wasOfflineRef.current = false;
    if (cart.length > 0) notify.success('Conexión restablecida. El carrito sigue listo para cobrar.');
  }
}, [isOnline, cart.length]);

  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('Todas');
const [filteredProducts, setFilteredProducts] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState('Efectivo');
  const [secondPaymentMethod, setSecondPaymentMethod] = useState('');
  const [showSecondPayment, setShowSecondPayment] = useState(false);
  const [amountReceived, setAmountReceived] = useState(0);
  const [secondAmountReceived, setSecondAmountReceived] = useState(0);
  const [change, setChange] = useState(0);
  const [customerName, setCustomerName] = useState('');
  const barcodeScannerRef = useRef(null);
const handleAperturaCaja = async () => {
  if (!montoApertura || isNaN(montoApertura) || Number(montoApertura) <= 0) {
    alert('Debes ingresar un monto de apertura válido.');
    return;
  }
  setAperturando(true);

try {
  const cash = await aperturarCaja(currentUser, montoApertura, isOnline);

  setCajaAbierta(true);
  setMostrandoModalApertura(false);
  setCajaActual({
    id: cash.id,
    ...cash,
    user: cash.user || (currentUser?.email ?? currentUser),
    fecha: cash.fecha || toLocalYMD(new Date()),
    hora: cash.hora || new Date().toLocaleTimeString(),
    montoApertura: Number(cash.montoApertura ?? montoApertura),
    estado: cash.estado || "abierta"
  });
} catch (e) {
notify.error(e?.message || "No se pudo aperturar la caja.");
} finally {
  setAperturando(false);
}
};

const [showPayModal, setShowPayModal] = useState(false);
const [showExpenseModal, setShowExpenseModal] = useState(false);
const [showEntryModal, setShowEntryModal] = useState(false);
const [expenseForm, setExpenseForm] = useState({
  amount: '',
  category: 'Gasto menor',
  description: '',
});
const [entryForm, setEntryForm] = useState({
  amount: '',
  notes: '',
});

// F9 abre/cierra modal de cobro
useEffect(() => {
  const onKey = (e) => {
    if (e.key === 'F9') {
      e.preventDefault();
      setShowPayModal(v => !v);
    }
  };
  window.addEventListener('keydown', onKey);
  return () => window.removeEventListener('keydown', onKey);
}, []);

// Cuando abres el modal, desactiva el autoFocus del escáner
useEffect(() => {
  if (showPayModal) {
    // si usas scannerLocked para autofocus:
    // setScannerLocked(false);
  }
}, [showPayModal]);


// estados (junto a los demás)
const [scannerLocked, setScannerLocked] = useState(false);

useEffect(() => {
  const onKey = (e) => { if (e.key === 'F8') setScannerLocked(v => !v); };
  window.addEventListener('keydown', onKey);
  return () => window.removeEventListener('keydown', onKey);
}, []);

useEffect(() => {
  if (scannerLocked) setTimeout(() => barcodeScannerRef.current?.focus(), 0);
}, [scannerLocked]);


 // Ancho dinámico del carrito + estilos de “line clamp” sin plugin
const [cartExpanded, setCartExpanded] = useState(false);
const clamp2 = { display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' };
const clamp3 = { display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' };

const [cajaAbierta, setCajaAbierta] = useState(false);
const [cajaActual, setCajaActual] = useState(null);
const [montoApertura, setMontoApertura] = useState('');
const [mostrandoModalApertura, setMostrandoModalApertura] = useState(false);
const [openIceCream, setOpenIceCream] = useState(false);
const [selectedIceProduct, setSelectedIceProduct] = useState(null);
const [openRecipeChoice, setOpenRecipeChoice] = useState(false);
const [selectedRecipeProduct, setSelectedRecipeProduct] = useState(null);
const [aperturando, setAperturando] = useState(false);
const [checandoCaja, setChecandoCaja] = useState(true);
// Modal "turno viejo"
const [dismissOldShift, setDismissOldShift] = useState(false);


// 🔎 Búsqueda y selección de cliente
const [customerInput, setCustomerInput] = useState('');          // lo que escribe el cajero (cc o nombre)
const [customerSuggestions, setCustomerSuggestions] = useState([]); // {id, name, cc, phone, email}[]
const [selectedCustomer, setSelectedCustomer] = useState(null);   // cliente elegido (si aplica)
const [showNewCustomerModal, setShowNewCustomerModal] = useState(false);
const [newCustomerData, setNewCustomerData] = useState({ name: '', cedula: '', email: '', phone: '' });
const [savingCustomer, setSavingCustomer] = useState(false);
const [pendingSaleAfterCustomer, setPendingSaleAfterCustomer] = useState(false);
const [processing, setProcessing] = useState(false);
const [compact, setCompact] = useState(false);
const itemsCount = useMemo(() => cart.reduce((acc, it) => acc + Number(it.quantity || 0), 0), [cart]);



const searchTimer = useRef(null);

// Limpia el iframe de impresión al desmontar el componente
useEffect(() => {
  return () => {
    if (__printFrame) {
      __printFrame.remove();
      __printFrame = null;
    }
  };
}, []);



 const categories = useMemo(() => {
   const set = new Set(['Todas']);
  sellableProducts.forEach(p => set.add(p?.category || p?.categoria || 'Sin categoría'));
 return Array.from(set);
 }, [sellableProducts]);useEffect(() => {
  let cancelled = false;
  let unsubscribeCashDoc = () => {};

  const clearOpenCash = () => {
    setCajaAbierta(false);
    setCajaActual(null);
    setMostrandoModalApertura(true);
  };

  const applyOpenCash = (cash) => {
    if (!cash?.id) {
      clearOpenCash();
      return;
    }
    setCajaAbierta(true);
    setCajaActual(cash);
    setMostrandoModalApertura(false);
  };

  // Mientras no haya usuario, no intentamos consultar caja.
  if (!currentUser) {
    clearOpenCash();
    setChecandoCaja(false);
    return () => {};
  }

  setChecandoCaja(true);
  setDismissOldShift(false);

  const loadAuthoritativeCash = async () => {
    try {
      // Consulta al backend de caja, que valida UID + cashLocks y lee Firestore
      // del lado servidor. Así no dependemos del cache local del navegador.
      const cash = await checkCajaAbierta(currentUser?.email ?? currentUser);
      if (cancelled) return;

      if (!cash?.id) {
        clearOpenCash();
        setChecandoCaja(false);

        // Si la caja se abre después (por el propio cajero o desde Turnos de Caja),
        // escuchar las cajas nuevas por UID sin aceptar resultados viejos del cache.
        if (currentUser?.uid) {
          const openByUidQuery = query(
            collection(db, 'cajas'),
            where('userUid', '==', currentUser.uid),
            where('estado', '==', 'abierta'),
            limit(1)
          );
          unsubscribeCashDoc = onSnapshot(
            openByUidQuery,
            (snap) => {
              if (cancelled || snap.metadata?.fromCache) return;
              if (snap.empty) {
                clearCachedOfflineCash();
                clearOpenCash();
                return;
              }
              const d = snap.docs[0];
              applyOpenCash({ id: d.id, ...d.data() });
            },
            (error) => {
              console.warn('No se pudo escuchar nuevas aperturas de caja:', error);
            }
          );
        }
        return;
      }

      applyOpenCash(cash);
      setChecandoCaja(false);

      // Una vez identificado el turno real, escuchar SOLO ese documento.
      // Si un administrador lo cierra desde otro equipo, el POS se actualiza
      // sin necesidad de F5. Se ignoran emisiones de cache porque el estado
      // inicial ya fue confirmado por el backend.
      unsubscribeCashDoc = onSnapshot(
        doc(db, 'cajas', cash.id),
        (snapshot) => {
          if (cancelled || snapshot.metadata?.fromCache) return;

          if (!snapshot.exists()) {
            clearCachedOfflineCash();
            clearOpenCash();
            return;
          }

          const data = snapshot.data() || {};
          const estado = String(data.estado || data.status || '').trim().toLowerCase();
          const sigueAbierta = estado === 'abierta' || estado === 'open';

          if (sigueAbierta) {
            applyOpenCash({ id: snapshot.id, ...data });
          } else {
            clearCachedOfflineCash();
            clearOpenCash();
          }
        },
        (error) => {
          console.warn('No se pudo escuchar el estado de la caja en tiempo real:', error);
        }
      );
    } catch (error) {
      if (cancelled) return;
      console.warn('No se pudo validar la caja por el servidor; se usará el estado local como respaldo.', error);

      const pendingOfflineCash = await getPendingOfflineCashOpen(currentUser?.uid).catch(() => null);
      if (cancelled) return;
      if (pendingOfflineCash?.id) {
        applyOpenCash(pendingOfflineCash);
        setChecandoCaja(false);
        return;
      }

      // Respaldo para escenarios sin Internet: conserva el comportamiento
      // anterior y permite que el modo offline siga funcionando.
      const q = query(
        collection(db, "cajas"),
        where("user", "==", currentUser?.email ?? currentUser),
        where("estado", "==", "abierta"),
        orderBy("openedAt", "desc"),
        limit(1)
      );

      unsubscribeCashDoc = onSnapshot(
        q,
        (snap) => {
          if (cancelled) return;
          if (snap.empty) {
            clearOpenCash();
          } else {
            const d = snap.docs[0];
            applyOpenCash({ id: d.id, ...d.data() });
          }
          setChecandoCaja(false);
        },
        (err) => {
          console.error("Error revisando caja:", err);
          clearOpenCash();
          setChecandoCaja(false);
        }
      );
    }
  };

  loadAuthoritativeCash();

  return () => {
    cancelled = true;
    unsubscribeCashDoc();
  };
}, [currentUser]);

 useEffect(() => {
 let tempProducts = sellableProducts; 

if (selectedCategory !== 'Todas') {
  tempProducts = tempProducts.filter(
    p => (p.category ?? p.categoria ?? 'Sin categoría') === selectedCategory
  );
}

const normalizedSearchTerm = normalizeSearchText(searchTerm);
    if (normalizedSearchTerm) {
      tempProducts = tempProducts.filter((product) => {
        const normalizedName = normalizeSearchText(product.name);
        const normalizedBarcode = normalizeSearchText(product.barcode);
        return (
          normalizedName.includes(normalizedSearchTerm) ||
          normalizedBarcode.includes(normalizedSearchTerm)
        );
      });
    }
    const seen = new Set();
    const deduped = [];
    for (const p of tempProducts) {
      const key = p?.id || p?.barcode || p?.name;
      if (key && seen.has(key)) continue;
      if (key) seen.add(key);
      deduped.push(p);
    }
    setFilteredProducts(deduped);
}, [searchTerm, selectedCategory, sellableProducts]);
  const subtotal = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const tax = Math.round(subtotal * (taxRate / 100));
  const total = subtotal + tax;

  useEffect(() => {
    const totalReceived = (Number(amountReceived) || 0) + (Number(secondAmountReceived) || 0);
    const calculatedChange = totalReceived - total;
    setChange(calculatedChange > 0 ? calculatedChange : 0);
  }, [amountReceived, secondAmountReceived, total]);



useEffect(() => {
  clearTimeout(searchTimer.current);

  // Si está vacío, limpia todo
  if (!customerInput) {
    setSelectedCustomer(null);
    setCustomerName('');
    setCustomerSuggestions([]);
    return;
  }

  // Solo dígitos
  const digits = customerInput.replace(/\D/g, '');

  // Si escribió letras, lo tomamos como nombre manual (no buscamos)
  if (!digits) {
    setSelectedCustomer(null);
    setCustomerName(customerInput);
    setCustomerSuggestions([]);
    return;
  }

  // Debounce 200ms
  searchTimer.current = setTimeout(async () => {
    try {
      const clientesRef = collection(db, 'clientes');
      let results = [];

      // 1) exacto string
      const exactSnap = await getDocs(
        query(clientesRef, where('cedula', '==', digits), limit(5))
      );
      results = exactSnap.docs.map(d => ({ id: d.id, ...d.data() }));

      // 2) exacto number (por si algunos docs la guardaron numérica)
      if (results.length === 0) {
        const asNumber = Number(digits);
        if (!Number.isNaN(asNumber)) {
          const numSnap = await getDocs(
            query(clientesRef, where('cedula', '==', asNumber), limit(5))
          );
          results = numSnap.docs.map(d => ({ id: d.id, ...d.data() }));
        }
      }

      // 3) prefijo
      if (results.length === 0) {
        const prefSnap = await getDocs(
          query(
            clientesRef,
            orderBy('cedula'),
            startAt(digits),
            endAt(digits + '\uf8ff'),
            limit(5)
          )
        );
        results = prefSnap.docs.map(d => ({ id: d.id, ...d.data() }));
      }

      setCustomerSuggestions(results);

      const first = results[0];
      if (first) {
        setSelectedCustomer(first);
        setCustomerName(first.name || '');
      } else {
        setSelectedCustomer(null);
        setCustomerName('');
      }
    } catch (e) {
      console.error('Error buscando cliente:', e);
      setCustomerSuggestions([]);
    }
  }, 200);

  return () => clearTimeout(searchTimer.current);
}, [customerInput, db]);

useEffect(() => {
  if (!showNewCustomerModal && pendingSaleAfterCustomer) {
    setPendingSaleAfterCustomer(false);
    setTimeout(() => handleProcessSale(), 0);
  }
}, [showNewCustomerModal, pendingSaleAfterCustomer]);

const handleNewCustomerFieldChange = (field, value) => {
  setNewCustomerData(prev => ({ ...prev, [field]: value }));
};

const handleCancelNewCustomerModal = () => {
  setShowNewCustomerModal(false);
  setCustomerInput('');
  setCustomerName('');
  setSelectedCustomer(null);
  setPendingSaleAfterCustomer(false);
};

const handleSaveNewCustomer = async () => {
  const name = (newCustomerData.name || '').trim();
  const cedula = String(newCustomerData.cedula || '').replace(/\D/g, '');
  if (!name) {
    alert('El nombre es obligatorio.');
    return;
  }
  if (!cedula) {
    alert('La cédula es obligatoria para guardar el cliente.');
    return;
  }
  setSavingCustomer(true);
  try {
    const payload = {
      cedula,
      name,
      email: (newCustomerData.email || '').trim(),
      phone: (newCustomerData.phone || '').trim(),
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    };
    await setDoc(doc(db, 'clientes', cedula), payload);
    const saved = { id: cedula, ...payload };
    setSelectedCustomer(saved);
    setCustomerName(name);
    setCustomerInput(cedula);
    setCustomerSuggestions([saved]);
    setShowNewCustomerModal(false);
    setPendingSaleAfterCustomer(true);
  } catch (error) {
    console.error('No se pudo guardar el cliente automático:', error);
    notify.error('No se pudo guardar el cliente. Intenta de nuevo.');
  } finally {
    setSavingCustomer(false);
  }
};

// Back (hardware / navegador) => volver al Menú
useEffect(() => {
  // Empuja un estado al entrar a POS, así “Atrás” cae aquí primero
  const marker = { valenposView: true };
  try { window.history.pushState(marker, ""); } catch {}

  const handlePop = (e) => {
    // Consumimos el back y mandamos al menú
    e.preventDefault?.();
    // Evita que se dispare otra vez mientras cambiamos de vista
    window.removeEventListener('popstate', handlePop);
    onBack?.(); // ← tu función que vuelve al menú
  };

  window.addEventListener('popstate', handlePop);

  return () => {
    window.removeEventListener('popstate', handlePop);
  };
}, []);



// --- Cálculo de recibido, faltante y cambio (para UI) ---
const n = (v) => Number(v || 0);
const totalReceived = n(amountReceived) + n(secondAmountReceived);
const missing = Math.max(0, total - totalReceived);
const changeCalc = Math.max(0, totalReceived - total);




const handleAddToCart = (product) => {
  // 1) Receta de helado (ya existía)
  if (product?.config?.isIceCream) {
    setSelectedIceProduct(product);
    setOpenIceCream(true);
    return;
  }

  // 2) Receta genérica (cualquier producto con config.recipe)
  const cfgRecipe = product?.config?.recipe;
  if (cfgRecipe) {
    const baseItems = Array.isArray(cfgRecipe.baseItems) ? cfgRecipe.baseItems : [];
    const choiceGroups = Array.isArray(cfgRecipe.choiceGroups) ? cfgRecipe.choiceGroups : [];

    const missingBaseItems = baseItems.filter((bi) => {
      const insumoId = bi.productId || bi.id;
      const insumo = insumoId ? (products || []).find(p => p.id === insumoId) : null;
      return !insumo || insumo.deleted === true;
    });
    if (missingBaseItems.length > 0) {
      alert(`No se puede vender "${product.name}" porque faltan insumos de su receta: ${missingBaseItems.map(item => item.name || item.productId || item.id).join(', ')}.`);
      return;
    }

    if (choiceGroups.length > 0) {
      setSelectedRecipeProduct(product);
      setOpenRecipeChoice(true);
      return;
    }

    // Construir los componentes (insumos) a partir de baseItems
    const comps = [];
    for (const bi of baseItems) {
      const insumoId = bi.productId || bi.id; // por si viene con otra clave
      if (!insumoId) continue;
      const insumo = (products || []).find(p => p.id === insumoId);
      if (!insumo) continue;

      const qtyPerUnit = Number(bi.qty || bi.quantity || 1);
      const unit = insumo.unit || bi.unit || 'unidad';

      comps.push({
        insumoId: insumo.id,
        name: insumo.name,
        unit,
        qtyPerUnit,
        costPrice: Number(insumo.costPrice || 0),
      });
    }

    if (comps.length === 0) {
      alert('La receta no tiene insumos base configurados.');
      return;
    }

    // Agregar al carrito como “receta dinámica” (igual que helados)
    const itemParaCarrito = {
      id: product.id,
      name: product.name,
      image: product.image || '',
      price: Number(product.price || 0),
      costPrice: Number(product.costPrice || 0),
      quantity: 1,
      recipeComponents: comps,
      _lineId: crypto.randomUUID(),
    };

    setCart(prev => [...prev, itemParaCarrito]);
    return;
  }

  // 3) Producto normal (sí requiere stock propio)
  const controlsOwnStock = requiresDirectStock(product);
  if (controlsOwnStock && Number(product.stock || 0) <= 0) {
    alert("No hay stock disponible para este producto.");
    return;
  }

  setCart((prevCart) => {
    const existingItem = prevCart.find((item) => item.id === product.id);
    if (existingItem) {
      if (controlsOwnStock && existingItem.quantity + 1 > Number(product.stock || 0)) {
        alert("No puedes agregar más de lo disponible en stock.");
        return prevCart;
      }
      return prevCart.map((item) =>
        item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
      );
    } else {
      return [...prevCart, { ...product, quantity: 1 }];
    }
  });
};


 const handleRemoveFromCart = (lineIdOrProductId) => {
  setCart(prev => prev.filter(item => (item._lineId ?? item.id) !== lineIdOrProductId));
 };
const handleQuantityChange = (lineIdOrProductId, newQuantity) => {
 const item = cart.find(current => (current._lineId ?? current.id) === lineIdOrProductId);
 if (!item) return;

 const decision = resolveRequestedSaleQuantity(item, newQuantity, item.stock);
 if (!decision.allowed) {
   notify.warn(`No hay stock disponible de ${item.name}.`);
   return;
 }
 if (decision.capped) {
   notify.warn(`La cantidad de ${item.name} se limitó al stock disponible (${decision.available}).`);
 }

  setCart(prev =>
   prev.map(item =>
     (item._lineId ?? item.id) === lineIdOrProductId ? { ...item, quantity: decision.quantity } : item
    )
 );
};

const nuevaEntradaDeCaja = async () => {
  if (!cajaAbierta || !cajaActual?.id) {
    alert("Debes tener una caja abierta para registrar una entrada.");
    return;
  }

  const valor = Number(String(entryForm.amount || "").replace(/\D/g, "")) || 0;
  if (valor <= 0) {
    notify.warn("Ingresa un valor válido para la entrada.");
    return;
  }

  const detalle = (entryForm.notes || "").trim();
  const fechaTurno = getFechaTurno();

  await addDoc(collection(db, "ingresos"), {
    date: new Date(),
    fecha: fechaTurno,
    totalEntryCost: valor,
    entryType: "manual",
    source: "caja",
    affectsCash: true,      // 👈 impacta efectivo del turno
    turnId: cajaActual.id,  // 👈 amarrado al turno
    createdBy: (currentUser?.email ?? currentUser ?? "desconocido"),
    notes: detalle,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });

  setEntryForm({ amount: "", notes: "" });
  setShowEntryModal(false);
  toast.success("Entrada de caja registrada.");
};

const nuevoGastoMenor = async () => {
  if (!cajaAbierta || !cajaActual?.id) {
    alert("Debes tener una caja abierta para registrar un gasto.");
    return;
  }
  const valor = Number(String(expenseForm.amount || '').replace(/\D/g, '')) || 0;
  if (valor <= 0) {
    notify.warn('Ingresa un valor válido para el gasto.');
    return;
  }

  const cat = (expenseForm.category || 'Gasto menor').trim() || 'Gasto menor';
  const detalle = (expenseForm.description || '').trim();

  const fechaTurno = getFechaTurno();          // ← ✅ define la fecha del turno

  // Medianoche LOCAL para evitar que se vea como “día siguiente”
  const midnightLocal = toLocalMidnight(fechaTurno);

  await addDoc(collection(db, "gastos"), {
    // fechas normalizadas
    date: midnightLocal,                        // Timestamp a medianoche local
    dateStr: fechaTurno,                        // YYYY-MM-DD del TURNO
    year: fechaTurno.slice(0,4),
    month: fechaTurno.slice(0,7),
    // datos
    amount: valor,
    category: cat,
    description: detalle,
    // caja
    affectsCash: true,
    turnId: cajaActual.id,
    // autor (mismo nombre que Gastos)
    registeredBy: (currentUser?.email ?? currentUser ?? "desconocido"),
    // extras
    supportFile: "",
    isRecurring: false,
    recurrencePeriod: "",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  markExpensesCacheDirty('pos-expense-created');

  setExpenseForm({ amount: '', category: 'Gasto menor', description: '' });
  setShowExpenseModal(false);
  toast.success("Gasto menor registrado.");
};

  
// ✅ Imprime con iframe (sin pop-up). Fallback a window.open si fuera necesario.
// ✅ Ticket térmico 80mm (cambia a 58mm si es tu rollo)
async function printClientTicketFallback(sale) {
  const fmt = fmtCOP;
  const safe = s => (s || '').toString();

const extraLines =
  (sale.table ? `<div class="kv"><span>Mesa</span><span>${safe(sale.table)}</span></div>` : "") +
  (sale.waiterName ? `<div class="kv"><span>Mesero</span><span>${safe(sale.waiterName)}</span></div>` : "");


  // 👇 NUEVO: lógica de consecutivo
const numberLabel = sale.provisional ? 'COMPROBANTE PROVISIONAL' : 'Consecutivo';
 const numberValue = sale.invoiceNumber || '-';

  const lineItems = sale.cart.map(it => {
    const desc = `${it.name} x${it.quantity}`;
    const total = fmt(it.price * it.quantity);
    return `<div class="row"><span class="desc">${desc}</span><span class="amt">${total}</span></div>`;
  }).join("");

  const metodo2 = sale.secondPaymentMethod
    ? `<div class="kv"><span>Método de Pago 2</span><span>${safe(sale.secondPaymentMethod)} - ${fmt(sale.secondAmountReceived)}</span></div>`
    : "";

  const storeTitle = settings?.ticketDisplayName || settings?.storeName || 'VALENPOS';
  const contactLines = [
    settings?.address,
    [settings?.phone, settings?.email].filter(Boolean).join(' · '),
  ]
    .filter(Boolean)
    .map(line => `<div class="sub">${line}</div>`)
    .join('');
  const logoHtml = settings?.storeLogo
    ? `<div class="logo"><img src="${settings.storeLogo}" alt="Logo" /></div>`
    : '';
  const impuestosHtml = settings?.taxEnabled
    ? `<div class="kv"><span>Impuestos</span><span>${fmt(sale.tax || 0)}</span></div>`
    : `<div class="kv"><span>Impuestos</span><span>Exento</span></div>`;

  const html = `
 <!doctype html><html><head><meta charset="utf-8" />
 <title>Ticket</title>
 <style>
  @page { size: 80mm auto; margin: 0 }
  * { box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact }
  html, body { width: 80mm }
  body {
    margin: 0;
    color: #000;
    font-family: Arial, Helvetica, sans-serif;
    -webkit-font-smoothing: none; /* texto más nítido en térmicas */
    -moz-osx-font-smoothing: auto;
    text-rendering: optimizeSpeed;
  }
  .ticket { width: 80mm; padding: 6mm 4mm; }
  .logo { text-align:center; margin-bottom:4px; }
  .logo img { max-height: 50px; max-width: 60px; object-fit: contain; }
  .title { text-align:center; font-weight:800; font-size:20px; margin: 0 0 6px; color:#000 }
  .sub   { text-align:center; font-size:15px; line-height:1.3; overflow-wrap:anywhere; color:#000; margin: 0 0 8px; font-weight:600 }
  .hr    { border-top:1px dashed #000; margin:6px 0 }
  .row   { display:flex; justify-content:space-between; gap:8px; font-size:16px; font-weight:600; line-height:1.35; margin: 4px 0; color:#000 }
  .desc  { flex:1; min-width:0; overflow-wrap:anywhere }
  .amt   { flex-shrink:0; text-align:right; white-space:nowrap }
  .kv    { display:flex; flex-wrap:wrap; justify-content:space-between; gap:2px 8px; font-size:16px; line-height:1.35; margin:4px 0; color:#000 }
  .kv > span { min-width:0; overflow-wrap:anywhere; max-width:100% }
  .kv > span:last-child { margin-left:auto; text-align:right }
  .tot   { font-weight:800; font-size:20px; color:#000 }
  .foot  { text-align:center; font-size:15px; line-height:1.35; margin-top:8px; color:#000 }
  .foot small { font-size:13px }
  @media print { html, body { width: 80mm } }
  </style>
  </head><body>
  <div class="ticket">
    ${logoHtml}
    <div class="title">${storeTitle}</div>
    <div class="sub">Ticket de venta</div>
    ${contactLines}
    <div class="kv"><span>Fecha</span><span>${safe(sale.date).replace('T',' ').slice(0,19)}</span></div>
    <!-- 👇 Reemplaza “Factura” por “Consecutivo” con estado -->
    <div class="kv"><span>${numberLabel}</span><span>${safe(numberValue)}</span></div>
    <div class="kv"><span>Cliente</span><span>${safe(sale.customerName) || 'Consumidor Final'}</span></div>
    ${extraLines}
    <div class="hr"></div>
    ${lineItems}
    <div class="hr"></div>
    <div class="kv"><span>Subtotal</span><span>${fmt(sale.subtotal)}</span></div>
    ${impuestosHtml}
    <div class="kv tot"><span>Total</span><span>${fmt(sale.total)}</span></div>
    <div class="hr"></div>
    <div class="kv"><span>Método de Pago</span><span>${safe(sale.paymentMethod)} - ${fmt(sale.amountReceived)}</span></div>
    ${metodo2}
    <div class="kv"><span>Cambio</span><span>${fmt(sale.change)}</span></div>
    <div class="hr"></div>
    <div class="foot">¡Gracias por su compra!<br/><small>Documento no válido como factura electrónica</small></div>
  </div>
</body></html>`;
  // Reusar 1 iframe
  if (!__printFrame) {
    __printFrame = document.createElement('iframe');
    Object.assign(__printFrame.style, { position:'fixed', right:0, bottom:0, width:0, height:0, border:0 });
    document.body.appendChild(__printFrame);
  }

  await new Promise(resolve => {
    const onload = () => { __printFrame.removeEventListener('load', onload); resolve(); };
    __printFrame.addEventListener('load', onload);
    __printFrame.srcdoc = html;
  });

  __printFrame.contentWindow?.focus();
  __printFrame.contentWindow?.print();
}

async function printClientTicket(sale) {
  try {
    await printTicket({
      storeName: settings?.ticketDisplayName || settings?.storeName || 'VALENPOS',
      address: settings?.address || '',
      phone: settings?.phone || '',
      email: settings?.email || '',
      invoiceNumber: sale.invoiceNumber || '',
      date: sale.date || new Date().toISOString(),
      customerName: sale.customerName || 'Consumidor Final',
      table: sale.table || '',
      waiterName: sale.waiterName || '',
      items: (sale.cart || []).map((item) => ({
        name: item.name,
        quantity: Number(item.quantity || 0),
        price: Number(item.price || 0),
        total: Number(item.price || 0) * Number(item.quantity || 0),
      })),
      subtotal: Number(sale.subtotal || 0),
      taxEnabled: Boolean(settings?.taxEnabled),
      tax: Number(sale.tax || 0),
      taxLabel: settings?.taxEnabled ? `Impuesto (${settings?.taxRate || 0}%)` : 'Impuesto',
      total: Number(sale.total || 0),
      paymentMethod: sale.paymentMethod || '',
      amountReceived: Number(sale.amountReceived || 0),
      secondPaymentMethod: sale.secondPaymentMethod || '',
      secondAmountReceived: Number(sale.secondAmountReceived || 0),
      change: Number(sale.change || 0),
      footer: sale.provisional
        ? 'VENTA PENDIENTE DE SINCRONIZAR - Este documento no es la factura definitiva'
        : 'Gracias por su compra',
    }, printingSettings, {
      browserPrint: () => printClientTicketFallback(sale),
    });
  } catch (error) {
    console.error('Fallo la impresion de venta:', error);
    throw error;
  }
}

// === Helper: devuelve la fecha (YYYY-MM-DD) del turno abierto ===
const getFechaTurno = () => {
  // Preferir openedAt cuando exista. toLocalYMD entiende tanto el Timestamp
  // de Firestore como el Timestamp serializado que devuelve nuestra API.
  if (cajaActual?.openedAt) {
    const openedYMD = toLocalYMD(cajaActual.openedAt);
    if (openedYMD) return openedYMD;
  }

  // `fecha` ya suele venir del backend como YYYY-MM-DD (America/Bogota).
  // Si es así, toLocalYMD la conserva sin desplazarla por zona horaria.
  if (cajaActual?.fecha) return toLocalYMD(cajaActual.fecha);
  if (cajaActual?.date) return toLocalYMD(cajaActual.date);
  return toLocalYMD(new Date());
};


const handleProcessSale = async () => {
  const saleDateKey = toLocalYMD(new Date());

  if (processing) return;

  let activeCustomer = selectedCustomer;
  const activeCustomerInput = customerInput;
  const digitsInput = customerInput.replace(/\D/g, '');
  if (!activeCustomer && digitsInput) {
    const match = customerSuggestions.find(c => String(c.cedula) === digitsInput);
    if (match) {
      activeCustomer = match;
      setSelectedCustomer(match);
    }
  }

  setProcessing(true);

  try {
    if (cart.length === 0) {
      notify.warn('El carrito está vacío. Agregue productos para realizar la venta.');
      return;
    }

    if (activeCustomerInput.trim() && !activeCustomer) {
      if (!isOnline) {
        notify.warn('No se pueden crear clientes sin Internet. Selecciona un cliente existente o usa Consumidor Final.');
        return;
      }
      setNewCustomerData({
        name: activeCustomerInput.trim(),
        cedula: activeCustomerInput.replace(/\D/g, ''),
        email: '',
        phone: ''
      });
      setShowNewCustomerModal(true);
      setProcessing(false);
      setPendingSaleAfterCustomer(true);
      return;
    }

    for (const item of cart) {
      if (requiresDirectStock(item)) {
        if (item.stock < item.quantity) {
          notify.warn(`No hay suficiente stock de ${item.name}. Disponible: ${item.stock}`);
          return;
        }
      }
    }

    // Las recetas pueden venderse aunque sus insumos queden negativos.
    // Los productos fijos siguen protegidos por la validación anterior y por la API.

    const totalReceived = (Number(amountReceived) || 0) + (Number(secondAmountReceived) || 0);
    if (totalReceived < total) {
      notify.warn('El monto recibido es insuficiente.');
      return;
    }

    let invoiceNumber = '';
    let invoiceSequence = null;

    const fechaTurno = getFechaTurno();
    const ahoraISO = new Date().toISOString();

    const saleDoc = {
      date: ahoraISO,
      fecha: fechaTurno,
      sellerUid: currentUser?.uid || null,
      sellerEmail: currentUser?.email ?? String(currentUser || ''),
      sellerDisplay: currentUser?.displayName ?? (currentUser?.email ?? String(currentUser || '')),
      seller: (currentUser?.username ?? currentUser?.email ?? String(currentUser || '')),
      user: (currentUser?.username ?? currentUser?.email ?? String(currentUser || '')),
      customerName: activeCustomer?.name || customerName || 'Consumidor Final',
      customerId: activeCustomer?.id || null,
      customerCC: activeCustomer?.cedula || (/^\d+$/.test(activeCustomerInput) ? activeCustomerInput.replace(/\D/g, '') : null),
      products: cart.map(item => ({
        id: item.id,
        name: item.name,
        quantity: item.quantity,
        qty: Number(item.quantity || 0),
        price: Number(item.price || 0),
        costPrice: item.costPrice || 0,
        barcode: item.barcode || '',
        recipe: Array.isArray(item.recipeComponents) ? item.recipeComponents : null
      })),
      subtotal,
      tax,
      total,
      paymentMethod,
      secondPaymentMethod: showSecondPayment ? secondPaymentMethod : null,
      amountReceived,
      secondAmountReceived: showSecondPayment ? secondAmountReceived : null,
      change: changeCalc,
      status: 'Completada',
      turnId: cajaActual?.id || null,
      dateKey: saleDateKey,
      storeId: STORE_ID,
    };

    const saleFingerprint = createSaleFingerprint({ saleDoc, storeId: STORE_ID });
    const saleAttempt = getOrCreateSaleAttempt(saleFingerprint);

    if (!isOnline) {
      if (paymentMethod !== 'Efectivo' || showSecondPayment) {
        notify.warn('Las ventas offline solo están disponibles con un único pago en efectivo.');
        return;
      }
      const queuedSale = await enqueueOfflineSale({
        saleDoc,
        storeId: STORE_ID,
        idempotencyKey: saleAttempt.key,
        fingerprint: saleFingerprint,
        dependsOn: cajaActual?.offlineOpenOperationId ? [cajaActual.offlineOpenOperationId] : [],
        reconcileOperationId: cajaActual?.offlineReconcileOperationId || null,
      });
      // La cola ya conserva la clave para reintentos. Liberarla aquí permite
      // registrar dos ventas offline legítimas aunque tengan el mismo carrito.
      clearSaleAttempt(saleAttempt.key);

      const provisionalPrint = {
        cart: cart.map(item => ({ ...item })),
        subtotal,
        tax,
        total,
        paymentMethod,
        amountReceived,
        secondPaymentMethod: null,
        secondAmountReceived: 0,
        change: changeCalc,
        date: ahoraISO,
        seller: currentUser,
        customerName: activeCustomer?.name || customerName || 'Consumidor Final',
        invoiceNumber: queuedSale.provisionalNumber,
        provisional: true,
      };

      setCart([]);
      localStorage.removeItem('valenpos_cart');
      setSearchTerm('');
      setSelectedCategory('Todas');
      setPaymentMethod('Efectivo');
      setSecondPaymentMethod('');
      setShowSecondPayment(false);
      setAmountReceived(0);
      setSecondAmountReceived(0);
      setChange(0);
      setCustomerName('');
      setCustomerInput('');
      setSelectedCustomer(null);
      setCustomerSuggestions([]);
      setShowPayModal(false);

      notify.success(`Venta guardada offline: ${queuedSale.provisionalNumber}. Se sincronizará al volver Internet.`);
      if (printingSettings.autoPrintSales) {
        try {
          await printClientTicket(provisionalPrint);
        } catch (_error) {
          notify.warn('La venta quedó guardada, pero no se pudo imprimir el comprobante provisional.');
        }
      }
      return;
    }

    const saleResult = await processSaleApi({
      saleDoc,
      storeId: STORE_ID,
      idempotencyKey: saleAttempt.key,
    });
    clearSaleAttempt(saleAttempt.key);

    const persistedInvoiceNumber = saleResult?.invoiceNumber || invoiceNumber;
    const persistedInvoiceSequence = Number(String(saleResult?.invoiceSequence || persistedInvoiceNumber || '').replace(/\D/g, '')) || null;
    const persistedSubtotal = Number(saleResult?.subtotal ?? subtotal);
    const persistedTax = Number(saleResult?.tax ?? tax);
    const persistedTotal = Number(saleResult?.total ?? total);
    const persistedChange = Number(saleResult?.change ?? changeCalc);
    invoiceNumber = persistedInvoiceNumber;
    invoiceSequence = persistedInvoiceSequence;
    refreshProducts?.();

    if (saleResult?.idempotentReplay) {
      notify.info(`La venta ya estaba registrada${invoiceNumber ? ` – Factura ${invoiceNumber}` : ''}. No se imprimió otra copia automáticamente.`);
    } else {
      notify.success(`Venta realizada con éxito${invoiceNumber ? ` – Factura ${invoiceNumber}` : ''}`);
    }
    await new Promise(r => setTimeout(r, 40));

    setCart([]);
    localStorage.removeItem('valenpos_cart');
    setSearchTerm('');
    setSelectedCategory('Todas');
    setPaymentMethod('Efectivo');
    setSecondPaymentMethod('');
    setShowSecondPayment(false);
    setAmountReceived(0);
    setSecondAmountReceived(0);
    setChange(0);
    setCustomerName('');
    setCustomerInput('');
    setSelectedCustomer(null);
    setCustomerSuggestions([]);

    setTimeout(async () => {
      const saleForPrint = {
        cart: cart.map(item => ({ ...item })),
        subtotal: persistedSubtotal,
        tax: persistedTax,
        total: persistedTotal,
        paymentMethod,
        secondPaymentMethod: showSecondPayment ? secondPaymentMethod : null,
        amountReceived,
        secondAmountReceived: showSecondPayment ? secondAmountReceived : null,
        change: persistedChange,
        date: ahoraISO,
        seller: currentUser,
        customerName: customerName || 'Consumidor Final',
        invoiceNumber,
      };

      if (printingSettings.autoPrintSales && !saleResult?.idempotentReplay) {
        try {
          await printClientTicket(saleForPrint);
        } catch (_error) {
          notify.warn('La venta se guardo, pero la impresion fallo.');
        }
      }
    }, 0);

  } catch (e) {
    console.error(e);
    if (e?.code === 'SALE_NETWORK_UNCERTAIN' || e?.code === 'SALE_PROCESSING') {
      notify.warn(e?.message || 'No se pudo confirmar la venta. Reintenta sin vaciar el carrito.');
    } else if (e?.code === 'SALE_INSUFFICIENT_STOCK' || e?.code === 'SALE_CASH_CLOSED' || e?.code === 'SALE_CASH_NOT_FOUND') {
      notify.warn(e?.message || 'La venta no pudo completarse.');
    } else {
      notify.error(e?.message || 'No se pudo procesar la venta.');
    }
  } finally {
    setProcessing(false);
  }
};
    // ... mantén este bloque igual ...
const handleBarcodeScan = (e) => {
  if (e.key === 'Enter') {
    e.preventDefault();
    const scannedBarcode = e.target.value.trim();
    const productFound = sellableProducts.find(p => p.barcode === scannedBarcode);
    if (productFound) {
      handleAddToCart(productFound);
      e.target.value = '';
    } else {
      alert('Producto no encontrado. Verifique el código de barras.');
    }
  }
};

  const paymentOptions = ['Efectivo', 'Nequi', 'Bancolombia', 'BBVA',"Daviplata","Rappi","Davivienda", 'Tarjeta Débito', 'Tarjeta Crédito',"Otros"];

// --- Aviso de turno viejo (solo después de la hora de corte) ---
const cutoffHour = 5; // 5am
const todayYMD = toLocalYMD(new Date());

// usamos SIEMPRE la función getFechaTurno() para sacar la fecha del turno
const turnoYMD = getFechaTurno();

const showOldShiftWarning =
  cajaAbierta &&
  cajaActual &&
  (turnoYMD !== todayYMD) &&
  (new Date().getHours() >= cutoffHour);

// El modal sólo aparece si NO lo hemos descartado todavía
const showOldShiftModal = showOldShiftWarning && !dismissOldShift;

if (loadingAll && !fullReady) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="px-6 py-4 bg-white rounded-xl shadow border text-gray-700 font-semibold">
        Cargando catálogo completo...
      </div>
    </div>
  );
}

return (
  <div className="p-6 flex flex-col min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
    {/* Contenedor centrado */}
<div className="mx-auto w-full max-w-[1280px] xl:max-w-[1400px] 2xl:max-w-[1600px] px-3 sm:px-4">

{!isOnline && (
  <div role="status" className="sticky top-2 z-50 mb-4 rounded-2xl border border-amber-300 bg-amber-50 px-4 py-3 shadow-lg shadow-amber-100">
    <div className="flex items-start gap-3">
      <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-amber-500 text-lg font-black text-white">!</span>
      <div>
        <p className="font-black text-amber-950">Sin conexión a Internet</p>
        <p className="mt-0.5 text-sm text-amber-900">Puedes vender únicamente en efectivo. La venta quedará pendiente en este dispositivo hasta recuperar Internet.</p>
      </div>
    </div>
  </div>
)}

{offlineSales.length > 0 && (
  <div className={`mb-4 rounded-2xl border px-4 py-3 ${offlineSales.some(item => item.status === 'needs_review') ? 'border-rose-300 bg-rose-50' : 'border-sky-200 bg-sky-50'}`}>
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <p className="font-black text-slate-950">{offlineSales.length} venta{offlineSales.length === 1 ? '' : 's'} pendiente{offlineSales.length === 1 ? '' : 's'} en este dispositivo</p>
        <p className="text-sm text-slate-600">
          {offlineSales.some(item => item.status === 'needs_review')
            ? 'Hay ventas que requieren revisión. La caja no podrá cerrarse.'
            : isOnline
              ? 'Se enviarán al servidor automáticamente.'
              : 'No cierres ni borres los datos de esta aplicación.'}
        </p>
      </div>
      {isOnline ? (
        <button
          type="button"
          onClick={() => syncNow()}
          disabled={syncingOfflineSales}
          className="rounded-full bg-white px-4 py-2 text-xs font-bold text-sky-800 shadow-sm disabled:cursor-wait disabled:opacity-60"
        >
          {syncingOfflineSales ? 'Sincronizando…' : 'Reintentar ahora'}
        </button>
      ) : (
        <span className="rounded-full bg-white px-3 py-1 text-xs font-bold text-slate-700 shadow-sm">Guardadas localmente</span>
      )}
    </div>
  </div>
)}

      {/* 🔴 Aviso de turno abierto anterior */}
{showOldShiftWarning && !showOldShiftModal && (
  <div className="mb-4 p-3 bg-red-50 rounded-lg border border-red-300 text-red-800">
    Tienes un turno abierto desde <b>{turnoYMD}</b>.
    Debes cerrarlo antes de abrir otro.
  </div>
)}

      {/* Header */}
      <div className="flex justify-between items-center mb-8">
        <button
          onClick={onBack}
          className="flex items-center text-blue-600 hover:text-blue-800 transition duration-200 px-4 py-2 rounded-lg border border-blue-200 hover:border-blue-400"
        >
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Volver al Menú
        </button>
        <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900 drop-shadow-sm">Punto de Venta</h1>
        <div className="w-32"></div>
      </div>

      {/* Layout principal */}
<div
 className="grid grid-cols-1 lg:grid-cols-2 gap-4 flex-1 min-h-0"
 >
{/* Columna izquierda (productos) */}
<div className="min-w-0 bg-white rounded-xl shadow-lg p-4 sm:p-6 flex flex-col h-[calc(100vh-160px)] min-h-[620px]">
    <h2 className="text-2xl font-bold text-gray-800 mb-2">Productos</h2>

  {/* Área scrollable de productos */}
  <div className="flex-1 min-h-0 overflow-hidden">
    <div className="h-full overflow-y-auto overscroll-contain pr-2">

      {/* Toolbar sticky dentro del scroll */}
      <div className="sticky top-0 z-10 -mt-1 pb-3 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80">
        <div className="flex flex-col md:flex-row gap-3">
          <input
            type="text"
            placeholder="Buscar producto…"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition shadow-sm"
          />
          <select
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition shadow-sm"
          >
            {categories.map(c => (<option key={c} value={c}>{c}</option>))}
          </select>
        </div>
      </div>

      {/* Lista (en 2XL se parte a 2 columnas) */}
      <div className="mt-2 grid grid-cols-1 2xl:grid-cols-2 gap-2">
        {filteredProducts.length > 0 ? (
          filteredProducts.map((product, i) => (
            <button
              key={product?.id ?? product?.barcode ?? `idx-${i}`}
              onClick={() => handleAddToCart(product)}
              className="w-full text-left flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200 hover:bg-gray-100 transition group"
            >
              <div className="flex items-center gap-3 min-w-0">
                {product.image && (
                  <img
                    src={product.image}
                    alt={product.name}
                    className="h-12 w-12 object-cover rounded-md shadow-sm"
                  />
                )}
                <div className="min-w-0">
                  <p className="font-semibold text-gray-800 truncate">{product.name}</p>
                  <p className="text-xs text-gray-500">Cód: {product.barcode}</p>
                  {Number(product.stock || 0) <= 0 && requiresDirectStock(product) && (
                    <span className="mt-1 inline-block px-2 py-0.5 bg-red-100 text-red-700 text-[11px] rounded-full">
                      Sin stock
                    </span>
                  )}
                </div>
              </div>
<p className="font-bold text-blue-600 whitespace-nowrap">
  {fmtCOP(product.price)}
</p>
            </button>
          ))
        ) : (
          <p className="text-center text-gray-500 py-8">No se encontraron productos.</p>
        )}
      </div>
    </div>
  </div>
</div>

{/* Columna media (Cobro) — solo XL+ */}
<div className="hidden">
    <h2 className="text-2xl font-bold text-gray-800 mb-2">Cobro</h2>

  <div className="flex-1 overflow-y-auto pr-1">
    <PaymentsBlock
      paymentOptions={paymentOptions}
      paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod}
      amountReceived={amountReceived} setAmountReceived={setAmountReceived}
      showSecondPayment={showSecondPayment} setShowSecondPayment={setShowSecondPayment}
      secondPaymentMethod={secondPaymentMethod} setSecondPaymentMethod={setSecondPaymentMethod}
      secondAmountReceived={secondAmountReceived} setSecondAmountReceived={setSecondAmountReceived}
      missing={missing} changeCalc={changeCalc} total={total} fmtCOP={fmtCOP}
      customerInput={customerInput} setCustomerInput={setCustomerInput}
      setCustomerName={setCustomerName} setSelectedCustomer={setSelectedCustomer}
      customerSuggestions={customerSuggestions}
      setCustomerSuggestions={setCustomerSuggestions}
    />
  </div>
</div>



        {/* Columna derecha (carrito) */}
{/* Columna derecha (carrito) */}
<div className="min-w-0 bg-white rounded-xl shadow-lg p-4 sm:p-6 flex flex-col h-[calc(100vh-160px)] min-h-[620px] overflow-hidden">
  <div className="flex items-center justify-between mb-4 shrink-0">
  <h2 className="text-2xl font-bold text-gray-800">
  Carrito de Compras <span className="text-sm text-gray-500 font-normal">({itemsCount} ítems)</span>
</h2>

  <div className="flex items-center gap-2">
    {cajaAbierta && cajaActual?.id && (
      <>
        <button
          onClick={() => setShowEntryModal(true)}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-emerald-200 text-emerald-700 hover:bg-emerald-50 transition"
          title="Agregar efectivo a caja"
        >
          <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M11 5a1 1 0 0 1 2 0v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0v-6H5a1 1 0 1 1 0-2h6V5z"/></svg>
          <span className="hidden xl:inline">Efectivo</span>
        </button>
        <button
          onClick={() => setShowExpenseModal(true)}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-rose-200 text-rose-700 hover:bg-rose-50 transition"
          title="Registrar gasto menor"
        >
          <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M5 11a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H5z"/></svg>
          <span className="hidden xl:inline">Gasto</span>
        </button>
      </>
    )}

  </div>
</div>

{/* ✅ CONTENEDOR DEL CARRITO: padre SIN overflow; hijo de ítems CON overflow */}
<div className="flex-1 min-h-0 flex flex-col">

  {/* 🔝 Escáner — fijo (sin sticky) */}
  <div className="shrink-0 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80 pb-3 border-b border-gray-200">
    <div className="flex items-center justify-between mb-1">
      <label className="block text-sm font-medium text-gray-700">
        Escanear Código de Barras
      </label>
      <button
        type="button"
        onClick={() => setScannerLocked(v => !v)}
        className="text-xs px-2 py-1 rounded border border-gray-300 bg-gray-50 hover:bg-gray-100"
        title="F8 para alternar"
      >
        {scannerLocked ? 'Escáner ON (F8)' : 'Escáner OFF (F8)'}
      </button>
    </div>

    <input
      type="text"
      ref={barcodeScannerRef}
      autoFocus={scannerLocked}
      onKeyDown={handleBarcodeScan}
      placeholder="Escanee o ingrese código de barras"
      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 shadow-sm"
    />
  </div>

  {/* 🧾 Lista del carrito — ESTE es el único que scrollea */}
<div className="flex-1 overflow-y-auto rounded-lg bg-white/50 mt-2 min-h-[240px] max-h-[55vh]">
    <div className="pr-2 p-2 space-y-3">
      {cart.length === 0 ? (
        <p className="text-center text-gray-500 p-4 border border-dashed border-gray-300 rounded-lg">
          Agrega productos escaneando o seleccionando.
        </p>
      ) : (
        cart.map((item) => (
          <div
            key={item._lineId ?? item.id ?? item.barcode}
            className={`flex items-start justify-between gap-3 ${compact ? 'p-2' : 'p-3'} bg-blue-50 rounded-lg shadow-sm border border-blue-200`}
          >
            <div className="flex gap-3 flex-1 min-w-0">
              {!compact && item.image && (
                <img
                  src={item.image}
                  alt={item.name}
                  className="h-14 w-14 object-cover rounded-md shadow-sm"
                />
              )}
              <div className="min-w-0">
                {/* Nombre: 2 líneas máximo con tooltip completo */}
                <p className="font-semibold text-gray-800" title={item.name} style={clamp2}>
                  {item.name}
                </p>

                {/* Sabores / insumos */}
                {Array.isArray(item.recipeComponents) && item.recipeComponents.length > 0 && (
                  <p
                    className="text-xs text-gray-700 mt-0.5"
                    title={item.recipeComponents.map(c => c.name).join(', ')}
                    style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}
                  >
                    {item.recipeComponents.map(c => c.name).join(' · ')}
                  </p>
                )}

                <p className="text-xs text-gray-500 mt-1">
                  {fmtCOP(item.price)} c/u
                </p>
              </div>
            </div>

            <div className="flex items-center gap-2 shrink-0">
              <input
                type="number"
                min="1"
                value={item.quantity}
                onChange={(e) =>
                  handleQuantityChange(item._lineId ?? item.id, parseInt(e.target.value || '1', 10))
                }
                className="w-16 px-2 py-1 border border-gray-300 rounded-md text-center focus:ring-blue-500 focus:border-blue-500"
              />
              <div className="text-right">
                <p className="font-bold text-base text-gray-900 whitespace-nowrap">
                  {fmtCOP(item.price * item.quantity)}
                </p>
                <button
                  onClick={() => handleRemoveFromCart(item._lineId ?? item.id)}
                  className="text-red-500 hover:text-red-700 p-1 rounded-full hover:bg-red-100"
                  title="Quitar"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  </div>

  {/* 💵 Totales — fijos */}
  <div className="border-t border-gray-200 pt-4 space-y-2 shrink-0">
    <div className="flex justify-between text-lg font-medium text-gray-700">
      <span>Subtotal:</span>
      <span>{fmtCOP(subtotal)}</span>
    </div>
    <div className="flex justify-between text-3xl font-bold text-gray-900 mt-2">
      <span>Total:</span>
      <span>{fmtCOP(total)}</span>
    </div>
  </div>

{/* Botón COBRAR para pantallas chicas (abre modal) */}
<button
  onClick={() => setShowPayModal(true)}
 className="w-full mt-4 px-6 py-3 bg-blue-600 text-white rounded-lg text-lg font-semibold hover:bg-blue-700 transition duration-200 shadow-md hover:shadow-lg disabled:cursor-not-allowed disabled:bg-gray-400 disabled:shadow-none"
  disabled={processing || cart.length === 0 || total === 0 || !cajaAbierta}
  title={isOnline ? 'F9 también abre el cobro' : 'Guardar venta en efectivo para sincronizar después'}
>
  {isOnline ? 'Cobrar (F9)' : 'Cobrar offline · Solo efectivo'}
</button>


{/* Botón procesar: visible inline sólo XL+ */}
<button
  onClick={handleProcessSale}
className="hidden"
  disabled={processing || cart.length === 0 || total === 0 || missing > 0 || !cajaAbierta || (!isOnline && (paymentMethod !== 'Efectivo' || showSecondPayment))}
>
  {processing ? 'Procesando…' : 'Procesar Venta'}
</button>
</div>

        </div>
      </div>
    </div>


    {/* Modales / toasts */}
    <IceCreamPOS
      open={openIceCream}
      product={selectedIceProduct}
      products={products}
      onClose={() => { setOpenIceCream(false); setSelectedIceProduct(null); }}
      onAddToCart={(item) => {
        setCart(prev => [...prev, { ...item, _lineId: crypto.randomUUID() }]);
      }}
    />

    <RecipeChoicePOS
      open={openRecipeChoice}
      product={selectedRecipeProduct}
      products={products}
      onClose={() => { setOpenRecipeChoice(false); setSelectedRecipeProduct(null); }}
      onAddToCart={(item) => {
        setCart(prev => [...prev, { ...item, _lineId: crypto.randomUUID() }]);
      }}
    />

    <ToastContainer
      position="top-center"
      theme="colored"
      newestOnTop
      limit={3}
      closeOnClick
      pauseOnFocusLoss={false}
    />


{showPayModal && (
  <div className="fixed inset-0 z-[120] bg-black/50 flex items-end sm:items-center justify-center p-0 sm:p-6">
    <div className="bg-white w-full sm:max-w-2xl rounded-t-2xl sm:rounded-2xl shadow-2xl overflow-hidden">
      <div className="px-4 sm:px-6 py-4 border-b flex items-center justify-between">
        <h3 className="text-xl font-bold">Cobro</h3>
        <button onClick={() => setShowPayModal(false)} className="text-gray-500 hover:text-gray-700">✕</button>
      </div>

      <div className="p-4 sm:p-6 max-h-[75vh] overflow-y-auto">
        <div className="flex items-baseline justify-between mb-4">
          <span className="text-lg text-gray-600">Total</span>
          <span className="text-3xl font-extrabold text-gray-900">{fmtCOP(total)}</span>
        </div>

<PaymentsBlock
  paymentOptions={paymentOptions}
  paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod}
  amountReceived={amountReceived} setAmountReceived={setAmountReceived}
  showSecondPayment={showSecondPayment} setShowSecondPayment={setShowSecondPayment}
  secondPaymentMethod={secondPaymentMethod} setSecondPaymentMethod={setSecondPaymentMethod}
  secondAmountReceived={secondAmountReceived} setSecondAmountReceived={setSecondAmountReceived}
  missing={missing} changeCalc={changeCalc} total={total} fmtCOP={fmtCOP}
  customerInput={customerInput} setCustomerInput={setCustomerInput}
  setCustomerName={setCustomerName} setSelectedCustomer={setSelectedCustomer}
  customerSuggestions={customerSuggestions}
  setCustomerSuggestions={setCustomerSuggestions}   
/>
      </div>

      <div className="px-4 sm:px-6 py-4 border-t bg-gray-50">
        {!isOnline && (
          <p className="mb-3 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-center text-sm font-semibold text-amber-900">
            Se guardará localmente con comprobante provisional. Solo se permite un pago en efectivo.
          </p>
        )}
        <button
          onClick={() => {
            setShowPayModal(false);
            handleProcessSale();
          }}
          className="w-full px-6 py-3 bg-blue-600 text-white rounded-lg text-lg font-semibold hover:bg-blue-700 transition disabled:bg-gray-400"
          disabled={processing || cart.length === 0 || total === 0 || missing > 0 || !cajaAbierta || (!isOnline && (paymentMethod !== 'Efectivo' || showSecondPayment))}
        >
          {processing ? 'Procesando…' : isOnline ? 'Procesar Venta' : 'Guardar venta offline'}
        </button>
      </div>
    </div>
  </div>
)}


{showNewCustomerModal && (
  <div className="fixed inset-0 z-[130] bg-black/60 flex items-center justify-center p-4">
    <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl">
      <div className="px-6 py-4 border-b flex items-center justify-between">
        <h3 className="text-xl font-bold">Guardar Cliente</h3>
        <button onClick={handleCancelNewCustomerModal} className="text-gray-500 hover:text-gray-800">✕</button>
      </div>

      <div className="px-6 py-6 space-y-4">
        <div>
          <label className="block text-xs font-semibold text-gray-600 mb-1">Nombre completo</label>
          <input
            type="text"
            value={newCustomerData.name}
            onChange={(e) => handleNewCustomerFieldChange('name', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            placeholder="Juan Pérez"
          />
        </div>
        <div>
          <label className="block text-xs font-semibold text-gray-600 mb-1">Cédula</label>
          <input
            type="text"
            value={newCustomerData.cedula}
            onChange={(e) => handleNewCustomerFieldChange('cedula', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            placeholder="Ej: 1092345678"
          />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">Email</label>
            <input
              type="email"
              value={newCustomerData.email}
              onChange={(e) => handleNewCustomerFieldChange('email', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              placeholder="ejemplo@mail.com"
            />
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">Teléfono</label>
            <input
              type="text"
              value={newCustomerData.phone}
              onChange={(e) => handleNewCustomerFieldChange('phone', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              placeholder="Ej: 3001234567"
            />
          </div>
        </div>
      </div>

      <div className="px-6 py-4 border-t bg-gray-50 flex justify-between">
        <button
          type="button"
          onClick={handleCancelNewCustomerModal}
          className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
        >
          Cancelar
        </button>
        <button
          type="button"
          onClick={handleSaveNewCustomer}
          className="px-4 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 transition disabled:opacity-60"
          disabled={savingCustomer}
        >
          {savingCustomer ? 'Guardando...' : 'Guardar cliente y continuar'}
        </button>
      </div>
    </div>
  </div>
)}



{showExpenseModal && (
  <div className="fixed inset-0 z-[125] bg-black/50 flex items-center justify-center p-4">
    <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl overflow-hidden">
      <div className="px-5 py-4 border-b flex items-center justify-between">
        <div>
          <p className="text-sm text-gray-500">Registrar gasto</p>
          <h3 className="text-xl font-bold text-gray-800">Gasto menor del turno</h3>
        </div>
        <button
          onClick={() => setShowExpenseModal(false)}
          className="text-gray-500 hover:text-gray-700"
        >
          ✕
        </button>
      </div>

      <div className="px-5 py-5 space-y-4">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">
            Valor (COP)
          </label>
          <input
            type="number"
            min="0"
            inputMode="numeric"
            pattern="[0-9]*"
            value={expenseForm.amount}
            onChange={(e) =>
              setExpenseForm((p) => ({ ...p, amount: e.target.value.replace(/\D/g, '') }))
            }
            placeholder="Ej: 50000"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-rose-500"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">
            Categoría
          </label>
          <input
            type="text"
            value={expenseForm.category}
            onChange={(e) => setExpenseForm((p) => ({ ...p, category: e.target.value }))}
            placeholder="Ej: Transporte, Aseo"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-rose-500"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">
            Detalle / observación (opcional)
          </label>
          <textarea
            value={expenseForm.description}
            onChange={(e) => setExpenseForm((p) => ({ ...p, description: e.target.value }))}
            rows={2}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-rose-500 resize-none"
            placeholder="Ej: Compra de bolsas de basura"
          />
        </div>

        <div className="text-xs text-gray-500 flex items-center gap-2">
          <span className="inline-flex items-center px-2 py-1 rounded bg-gray-100 text-gray-700 font-semibold">
            Fecha del turno: {getFechaTurno()}
          </span>
          <span className="text-gray-500">Se asociará al turno actual.</span>
        </div>
      </div>

      <div className="px-5 py-4 border-t bg-gray-50 flex flex-col sm:flex-row gap-2 sm:justify-end">
        <button
          onClick={() => setShowExpenseModal(false)}
          className="w-full sm:w-auto px-4 py-2 rounded-lg border border-gray-300 bg-white hover:bg-gray-100 text-gray-700"
        >
          Cancelar
        </button>
        <button
          onClick={nuevoGastoMenor}
          className="w-full sm:w-auto px-4 py-2 rounded-lg bg-rose-600 text-white font-semibold hover:bg-rose-700"
        >
          Guardar gasto
        </button>
      </div>
    </div>
  </div>
)}

{showEntryModal && (
  <div className="fixed inset-0 z-[126] bg-black/50 flex items-center justify-center p-4">
    <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl overflow-hidden">
      <div className="px-5 py-4 border-b flex items-center justify-between">
        <div>
          <p className="text-sm text-gray-500">Registrar entrada</p>
          <h3 className="text-xl font-bold text-gray-800">Agregar efectivo a la caja</h3>
        </div>
        <button
          onClick={() => setShowEntryModal(false)}
          className="text-gray-500 hover:text-gray-700"
        >
          ✕
        </button>
      </div>

      <div className="px-5 py-5 space-y-4">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">
            Valor (COP)
          </label>
          <input
            type="number"
            min="0"
            inputMode="numeric"
            pattern="[0-9]*"
            value={entryForm.amount}
            onChange={(e) =>
              setEntryForm((p) => ({ ...p, amount: e.target.value.replace(/\D/g, "") }))
            }
            placeholder="Ej: 50000"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">
            Detalle / concepto (opcional)
          </label>
          <textarea
            value={entryForm.notes}
            onChange={(e) => setEntryForm((p) => ({ ...p, notes: e.target.value }))}
            rows={2}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 resize-none"
            placeholder="Ej: ajuste de caja, ingreso extraordinario..."
          />
        </div>

        <div className="text-xs text-gray-500 flex items-center gap-2">
          <span className="inline-flex items-center px-2 py-1 rounded bg-gray-100 text-gray-700 font-semibold">
            Fecha del turno: {getFechaTurno()}
          </span>
          <span className="text-gray-500">Se asociará al turno actual.</span>
        </div>
      </div>

      <div className="px-5 py-4 border-t bg-gray-50 flex flex-col sm:flex-row gap-2 sm:justify-end">
        <button
          onClick={() => {
            setShowEntryModal(false);
            setEntryForm({ amount: "", notes: "" });
          }}
          className="w-full sm:w-auto px-4 py-2 rounded-lg border border-gray-300 bg-white hover:bg-gray-100 text-gray-700"
        >
          Cancelar
        </button>
        <button
          onClick={nuevaEntradaDeCaja}
          className="w-full sm:w-auto px-4 py-2 rounded-lg bg-emerald-600 text-white font-semibold hover:bg-emerald-700"
        >
          Guardar entrada
        </button>
      </div>
    </div>
  </div>
)}


 {/* 🔒 Overlay: Apertura de caja */}
    {mostrandoModalApertura && (
      <div className="fixed inset-0 z-[100] bg-black/40 flex items-center justify-center p-4">
        <div className="bg-white w-full max-w-md rounded-xl shadow-2xl p-6">
          <h2 className="text-2xl font-bold mb-2">Apertura de Caja</h2>
          <p className="mb-4 text-gray-700">Para comenzar a vender, debes aperturar caja.</p>

          <input
            type="number"
            placeholder="Monto de apertura"
            value={montoApertura}
            onChange={(e) => setMontoApertura(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg mb-4 w-full"
          />

          <button
            onClick={handleAperturaCaja}
            disabled={aperturando}
            className="w-full mb-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-60"
          >
            {aperturando ? 'Aperturando…' : 'Aperturar Caja'}
          </button>

          <button
            onClick={onBack}
            className="w-full px-6 py-3 bg-gray-100 text-gray-800 rounded-lg hover:bg-gray-200 transition"
          >
            Volver al Menú Principal
          </button>
        </div>
      </div>
    )}

    {/* ⏳ Overlay: Cargando chequeo de caja */}
    {(checandoCaja && !mostrandoModalApertura) && (
      <div className="fixed inset-0 z-[90] bg-white/60 backdrop-blur-sm flex items-center justify-center">
        <div className="animate-pulse text-gray-600">Cargando punto de venta…</div>
      </div>
    )}

{showOldShiftModal && (
  <div className="fixed inset-0 z-[130] bg-black/50 flex items-center justify-center p-4">
    <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl overflow-hidden">
      <div className="px-5 py-4 border-b">
        <h3 className="text-xl font-bold">Caja abierta del día anterior</h3>
        <p className="text-sm text-gray-600 mt-1">
          Tienes un turno abierto con fecha <b>{turnoYMD}</b>. Ya pasó la hora de corte ({cutoffHour}:00).
        </p>
      </div>

      <div className="px-5 py-4 space-y-3 text-gray-800">
        <p className="text-sm">
          Puedes <b>ir a cerrarla ahora</b> o <b>continuar trabajando con esta misma caja</b>.
        </p>

        {/* Info de la caja actual, si la tienes */}
        {cajaActual?.id && (
          <div className="text-xs rounded-lg border border-amber-200 bg-amber-50 p-3">
            <div><b>Turno:</b> {cajaActual.id}</div>
            <div><b>Usuario:</b> {cajaActual.user || (currentUser?.email ?? '')}</div>
          </div>
        )}
      </div>

      <div className="px-5 py-4 bg-gray-50 border-t flex flex-col sm:flex-row gap-2 sm:justify-end">
        {/* Opción 1: Ir a cerrar */}
        <button
          onClick={() => {
            // Si el padre define un manejador global, llámalo:
            if (typeof window.__openCloseView === 'function') {
              window.__openCloseView({ from: 'POS', turnId: cajaActual?.id || null });
            } else {
              // Fallback: avisa cómo ir manual
              notify.info('Ve al Menú → Cierre de Caja para cerrarla.');
            }
          }}
          className="w-full sm:w-auto px-4 py-2 rounded-lg bg-rose-600 text-white font-semibold hover:bg-rose-700"
        >
          Ir a cerrar
        </button>

        {/* Opción 2: Continuar con la misma caja (si NO quieres bloquear) */}
        <button
          onClick={() => setDismissOldShift(true)}
          className="w-full sm:w-auto px-4 py-2 rounded-lg border border-gray-300 bg-white hover:bg-gray-100"
        >
          Continuar con esta caja
        </button>
      </div>
    </div>
  </div>
)}


  </div>
);

};

export default POSView;
